import React from "react";

import ReactDOM from "react-dom";

import {
  FiCalendar,
  FiClock,
  FiFileText,
  FiTrash2,
  FiUser,
  FiX,
} from "react-icons/fi";

import EmployeeStatusBadge
  from "../common/EmployeeStatusBadge";

import {
  formatEmployeeDate,
} from "../utils/employee.utils";

import "./EmployeeAttendance.css";


const AttendanceDetailsDrawer = ({
  open,

  attendance,

  onClose,

  onDelete,
}) => {

  if (
    !open ||
    !attendance
  ) {

    return null;

  }


  const employee =
    attendance?.employeeId &&
    typeof attendance.employeeId ===
      "object"
      ?
      attendance.employeeId
      :
      attendance?.employee ||
      {};


  return ReactDOM
    .createPortal(

      <div className="employee-attendance-drawer-root">

        <button
          type="button"
          className="employee-attendance-drawer-backdrop"
          onClick={
            onClose
          }
          aria-label="Close"
        />


        <aside className="employee-attendance-drawer">

          <header>

            <div>

              <span>
                ATTENDANCE DETAILS
              </span>

              <h2>
                Attendance Record
              </h2>

            </div>


            <button
              type="button"
              onClick={
                onClose
              }
            >

              <FiX />

            </button>

          </header>


          <div className="employee-attendance-drawer-body">

            <section className="employee-attendance-drawer-profile">

              <div className="employee-attendance-drawer-avatar">

                <FiUser />

              </div>


              <div>

                <small>
                  {
                    employee?.employeeCode ||
                    attendance?.employeeCode ||
                    "-"
                  }
                </small>

                <h3>
                  {
                    employee?.name ||
                    attendance?.employeeName ||
                    "-"
                  }
                </h3>

                <p>
                  {
                    employee?.department ||
                    "-"
                  }
                </p>

              </div>


              <EmployeeStatusBadge
                status={
                  attendance?.status
                }
              />

            </section>


            <section className="employee-attendance-detail-section">

              <h4>
                Attendance Information
              </h4>


              <div className="employee-attendance-detail-grid">

                <DetailItem
                  icon={
                    FiCalendar
                  }
                  label="Attendance Date"
                  value={
                    formatEmployeeDate(
                      attendance
                        ?.attendanceDate ||
                      attendance
                        ?.date
                    )
                  }
                />


                <DetailItem
                  icon={
                    FiClock
                  }
                  label="Check In"
                  value={
                    attendance
                      ?.checkIn ||
                    "-"
                  }
                />


                <DetailItem
                  icon={
                    FiClock
                  }
                  label="Check Out"
                  value={
                    attendance
                      ?.checkOut ||
                    "-"
                  }
                />


                <DetailItem
                  icon={
                    FiClock
                  }
                  label="Working Hours"
                  value={
                    attendance
                      ?.workingHours ??
                    attendance
                      ?.totalHours ??
                    "-"
                  }
                />

              </div>

            </section>


            {
              attendance?.remark
                ?
                (
                  <section className="employee-attendance-detail-section">

                    <h4>
                      Remark
                    </h4>


                    <div className="employee-attendance-detail-remark">

                      <FiFileText />

                      <p>
                        {
                          attendance.remark
                        }
                      </p>

                    </div>

                  </section>
                )
                :
                null
            }


            <section className="employee-attendance-detail-section">

              <h4>
                Record Information
              </h4>


              <div className="employee-attendance-info-grid">

                <div>

                  <span>
                    Created On
                  </span>

                  <strong>
                    {
                      formatEmployeeDate(
                        attendance
                          ?.createdAt
                      )
                    }
                  </strong>

                </div>


                <div>

                  <span>
                    Status
                  </span>

                  <strong>
                    {
                      String(
                        attendance
                          ?.status ||
                        "-"
                      )
                        .replace(
                          /_/g,
                          " "
                        )
                    }
                  </strong>

                </div>

              </div>

            </section>

          </div>


          <footer>

            <button
              type="button"
              onClick={
                onClose
              }
            >
              Close
            </button>


            <button
              type="button"
              className="employee-attendance-delete-btn"
              onClick={
                () =>
                  onDelete?.(
                    attendance
                  )
              }
            >

              <FiTrash2 />

              Delete Attendance

            </button>

          </footer>

        </aside>

      </div>,

      document.body

    );

};


const DetailItem = ({
  icon: Icon,

  label,

  value,
}) => (

  <div className="employee-attendance-detail-item">

    <span>

      <Icon />

    </span>


    <div>

      <small>
        {label}
      </small>

      <strong>
        {
          value ??
          "-"
        }
      </strong>

    </div>

  </div>

);


export default AttendanceDetailsDrawer;